export default "__VITE_ASSET__JwtSORM7__"